module.exports = __webpack_public_path__ + "static/media/stofferingen-44.76ea1841.jpg";